import request from '@/utils/request'

// 查询历史搜索列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/category/tenant/page',
        method: 'get',
        params: query,
    })
}
// 新增历史搜索
export function addObj(data) {
    return request({
        url: '/upkeep/category/tenant/add',
        method: 'post',
        data: data,
    })
}
// 详情
export function getObj(data) {
    return request({
        url: '/upkeep/category/tenant/add',
        method: 'post',
        data: data,
    })
}
// 删除历史搜索
export function delObj(data) {
    return request({
        url: '/upkeep/category/tenant/delete',
        method: 'post',
        data: data,
    })
}
// 维修分类
export function fetchList2(query) {
    return request({
        url: '/upkeep/category/page',
        method: 'get',
        params: query,
    })
}

// 导出  
export function exportExcel(query) {
    return request({
        url: '/upkeep/category/tenant/export',
        method: 'post',
        params: query,
        responseType: 'blob',
    })
}

 
